import React, { useEffect, useState } from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, FileDown, Loader2 } from "lucide-react";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

const fmtSize = (b) => (b > 0 ? `${(b / 1024 / 1024).toFixed(1)} MB` : "wird beim ersten Abruf erzeugt");

export const HandbookCard = () => {
  const [info, setInfo] = useState(null);
  const [downloading, setDownloading] = useState(false);

  useEffect(() => {
    apiClient.get("/docs/handbook/info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const download = async () => {
    setDownloading(true);
    try {
      const res = await apiClient.get("/docs/handbook", { responseType: "blob", timeout: 180000 });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "Systemhandbuch_Buchhaltung_Schweiz.pdf";
      a.click();
      URL.revokeObjectURL(url);
      toast.success("Systemhandbuch heruntergeladen");
      apiClient.get("/docs/handbook/info").then((r) => setInfo(r.data)).catch(() => {});
    } catch (err) {
      toast.error(err.response?.data?.detail || "Download fehlgeschlagen");
    } finally {
      setDownloading(false);
    }
  };

  return (
    <Card className="p-5 border border-slate-200 bg-white" id="section-handbuch" data-testid="settings-handbook-section">
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-lg bg-teal-50 text-teal-700 flex items-center justify-center shrink-0">
          <BookOpen className="h-4.5 w-4.5" />
        </div>
        <div className="flex-1">
          <h2 className="text-sm font-medium text-slate-900">Systemhandbuch (PDF)</h2>
          <p className="mt-1 text-sm text-slate-500">
            Vollständige Dokumentation aller Funktionen: Teil A Anwenderhandbuch (Posteingang, Belege, Rechnungen,
            Bank, Lohn, Abschluss …) mit Screenshots, Teil B Technische Referenz (Architektur, KI-Pipeline,
            API-Endpunkte, Datenmodell, Zeitpläne, Integrationen).
          </p>
          {info && (
            <p className="mt-2 text-xs text-slate-500" data-testid="settings-handbook-info">
              {info.chapters.length} Kapitel · {info.screenshots} Screenshots · {fmtSize(info.size_bytes)}
            </p>
          )}
          <Button size="sm" className="mt-4" onClick={download} disabled={downloading} data-testid="settings-handbook-download-button">
            {downloading ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <FileDown className="h-4 w-4 mr-1.5" />}
            Handbuch herunterladen (PDF)
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default HandbookCard;
